export default {
    namespaced: true,
    state: {
        open: false,
        selectedId: null
    },
    mutations: {
        toggle(state) {
            state.open = !state.open;
        },
        open(state) {
            state.open = true;
        },
        close(state) {
            state.open = false;
        },
        select(state, payload) {
            state.selectedId = payload.id;
        }
    },
    actions: {
        toggle({commit}) {
            commit('toggle');
        },
        open({commit}) {
            commit('open');
        },
        close({commit}) {
            commit('close');
        },
        select({commit}, payload) {
            commit('select', payload);
        }
    }
};
